"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Grid_1 = require("@material-ui/core/Grid");
const HBFilter_1 = require("@components/library/HBFilter");
const HBLink_1 = require("@components/library/HBLink");
const ProductTags = ({ className, tags = [] }) => !!(tags === null || tags === void 0 ? void 0 : tags.length) && (React.createElement(Grid_1.default, { container: true, spacing: 1, className: className }, tags === null || tags === void 0 ? void 0 : tags.map(({ id, name, to }) => (React.createElement(Grid_1.default, { key: id, item: true, component: HBLink_1.default, to: to },
    React.createElement(HBFilter_1.default, { label: name }))))));
exports.default = ProductTags;
